import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const hasDownloadedHistoryOrders = createSelector(
    historyOrdersState,
    (historyOrders) => historyOrders.downloadedDate !== null && !historyOrders.orders.some((order) => order.downloadedDate === null),
);
